import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.API_URL
Vue.use(VueAxios, axios)

export default {
  root: process.env.API_URL
}
